export default __webpack_public_path__ + "static/media/blueblock.41882f76.webp";